import script from "./QuyDinhUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuyDinhUserView.vue?vue&type=script&setup=true&lang=js"

import "./QuyDinhUserView.vue?vue&type=style&index=0&id=4a04e9e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a04e9e8"]])

export default __exports__